module.exports = __webpack_public_path__ + "static/media/intro.7c2d7826.mp3";